//Коммент на русском
export const createRoutingList = async (params) => {
    const { waypoints,
            startPoint = null,
            comment = ' ',
            IsCycle = false,
            RLDriver,
            startDate,
            duration} = params
    try {
        //const currentUser = await BX.rest.callMethod("im.user.get", {});
        //const lastName = currentUser['answer']['result']['last_name'];
        //const title = "МЛ" + ` ${lastName} ${comment?comment: ' '}`;
        const title = "МЛ";
        let yandexRouteLink
        if (startPoint){
            yandexRouteLink = IsCycle ? createLinkYNav([startPoint, ...waypoints]) : createLinkYNav([startPoint, ...waypoints]);
        } else {
            yandexRouteLink = createLinkYNav(waypoints)
        }
        console.log(yandexRouteLink);
        //window.open(yandexRouteLink, '_blank');

        return yandexRouteLink;
        
        // const selectedItems = waypoints.map(element => element['ID']);
        // const params = {
        //     'entityTypeId': 133,
        //     'fields': {
        //         'title': title,
        //         'ufCrm6Upd': selectedItems,
        //         'ufCrm6RoutingRouteYandex': yandexRouteLink ?? null,
        //         'ufCrm6Driver': RLDriver,
        //         'ufCrm6StartDate': startDate,
        //         'ufCrm6Duration': duration
        //     }
        // };
        // let timeForUpd = waypoints.length * 60;
        // timeForUpd = Math.floor(timeForUpd / selectedItems.length);

        // const response = await BX.rest.callMethod('crm.item.add', params);

        // for (let i = 0; i < selectedItems.length; i++) {
        //     await BX.rest.callMethod('crm.item.update', {
        //         entityTypeId: 168,
        //         id: selectedItems[i],
        //         fields: {
        //             'ufCrm5DeliveryTime': String(timeForUpd),
        //         },
        //     });
        // }
        // return response;
    } catch (error) {
        throw error;
    }
}

const createLinkYNav = (waypoints) => {
    const linkStart = "https://yandex.ru/maps/?ll=65.600579%2C57.151417&mode=routes";
    let linkRoutes = "&rtext=";
    const linkEnd = "&rtt=auto&z=14.46";

    linkRoutes += waypoints.map(point => point['coordinates'][1] + '%2C' + point['coordinates'][0]).join('~');

    return linkStart + linkRoutes + linkEnd;
}

export const getEmployeeList = async() => {

    // const employee = [];

    const employee = [
        {
            ID: 1,
            LAST_NAME: "Иванов",
            NAME: "Иван",
            SECOND_NAME: "Иванович",
            UF_USR_GUID: "550e8400-e29b-41d4-a716-446655440001"
        },
        {
            ID: 2,
            LAST_NAME: "Петров",
            NAME: "Петр",
            SECOND_NAME: "Петрович",
            UF_USR_GUID: "550e8400-e29b-41d4-a716-446655440002"
        },
        {
            ID: 3,
            LAST_NAME: "Сидорова",
            NAME: "Мария",
            SECOND_NAME: "Сергеевна",
            UF_USR_GUID: "550e8400-e29b-41d4-a716-446655440003"
        },
        {
            ID: 4,
            LAST_NAME: "Козлов",
            NAME: "Алексей",
            SECOND_NAME: "Владимирович",
            UF_USR_GUID: "550e8400-e29b-41d4-a716-446655440004"
        },
        {
            ID: 5,
            LAST_NAME: "Смирнова",
            NAME: "Ольга",
            SECOND_NAME: "Дмитриевна",
            UF_USR_GUID: "550e8400-e29b-41d4-a716-446655440005"
        }
    ];    
    
    //const employeeSize = 50;
    // try {
    //     let start = 0
    //     while (true) {
    //         const fields = {
    //             select: [
    //                 "ID",
    //                 "LAST_NAME",
    //                 "NAME",
    //                 "SECOND_NAME",
    //                 "UF_USR_GUID"
    //             ],
    //             start,
    //             order: {
    //             },
    //             filter:{
    //                 USER_TYPE:"employee",
    //                 UF_DEPARTMENT: 51
    //             }
    //         };
    //         const response = await BX.rest.callMethod('user.get', fields);
    //         if (!response || !response.answer || !response.answer.result) {
    //             console.error('Ошибка в ответе API:', response);
    //             throw new Error('Ошибка при запросе данных!');
    //         }
    //         const items = response.answer.result;
    //         employee.push(...items);
    //         if (items.length < employeeSize) break;
    //         start += employeeSize;
    //     }
    //     return employee

    // }
    // catch (e){
    //     console.error('Ошибка запроса:', e);
    //     throw new Error('Произошла ошибка! Обратитесь к администраторам портала.');
    // }

    return employee;
}

export const getStorages = async() =>  {
    //let result = [];
    let result = [
        {
            "ID": 0,
            // "coordinates": [65.5342, 57.1522],
            // "title": "Тюменский цирк",
            // "type": "attraction",
            // "address": "ул. Первомайская, 15, Тюмень, 625000",
            // "price": 1000
        }
    ];
    return result
    try {
    //     let start = 0
    //     while (true) {
    //         const fields = {
    //             IBLOCK_TYPE_ID: 'lists',
    //             IBLOCK_ID:'31',
    //             start
    //         }
    //         const response = await BX.rest.callMethod('lists.element.get', fields);

    //         if (!response || !response.answer || !response.answer.result) {
    //             console.error('Ошибка в ответе API:', response);
    //             throw new Error('Ошибка при запросе данных!');
    //         }
    //         result.push(...response.answer.result);
    //         if (!response.answer.next) break;

    //         start = response.answer.next;
    //     }
    } catch (e) {
        console.error(e);
    }
}